/**
 * @format
 */
import {createSet, add, each} from '@acng/frontend-bounty/collection.js';
import {replaceContent} from '@acng/frontend-bounty/dom/template.js';

const purgeNamespace = createSet();

/**
 * @param {HTMLTemplateElement} namespace
 * @returns {void}
 */
const registerPurge = (namespace) => add(purgeNamespace, namespace);

/**
 * @param {HTMLTemplateElement} namespace
 * @returns {void}
 */
const purge = (namespace) => replaceContent(namespace);

/**
 * @returns {void}
 */
const purgeAll = () => each(purgeNamespace, purge);

export {registerPurge, purgeAll};
